<template>
  <k-text-field v-model="val" :label="label || title" readonly></k-text-field>
</template>

<script>
export default {
	props: [
		'name',
		'value',
		'label',
    'title'
	],
	computed: {
    val: {
      get () {
        return _.get(this.value, this.name);
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
